(function () {
    const contactForm = document.querySelector('#cf-form');
    const requiredFields = ['from', 'email', 'message'];

    if (contactForm) {
        requiredFields.forEach(function (item) {
            document.getElementById(item).addEventListener("focus", function () {
                document.getElementById(item + "-error").classList.add('d-none');
            });
        });
        contactForm.addEventListener('submit', (event) => {
            event.preventDefault();
            let passesValidation = true;
            const data = new FormData(contactForm);
            requiredFields.forEach(function (item) {
                if (data.get(item).length === 0) {
                    passesValidation = false;
                    document.getElementById(item + '-error').classList.remove('d-none');
                }
            });
            if (passesValidation) {
                const formCard = document.getElementById('cf-form-card');
                const formSending = document.getElementById('cf-form-sending');
                const xhr = new XMLHttpRequest();
                xhr.open('POST', 'https://mailer.waxconn.com/contact-email');
                xhr.onloadstart = function () {
                    formCard.classList.add('d-none');
                    formSending.classList.remove('d-none');
                }
                xhr.onloadend = function () {
                    formSending.classList.add('d-none');
                    (this.readyState === 4 && this.status === 200)
                        ? document.getElementById('cf-thank-you').classList.remove('d-none')
                        : document.getElementById('cf-error-sending').classList.remove('d-none')
                };
                xhr.send(data);
            }
        });
    }
}(window));
